import React from 'react'
import { makeStyles } from '@material-ui/core'
import type { Theme } from '@material-ui/core'
import type { ItemTableCellProps } from '../../../ItemTable/ItemTableCell'
import ItemTableCell from '../../../ItemTable/ItemTableCell'

export interface AreaSubstrateItemCellProps extends ItemTableCellProps {
  isPrep?: boolean
  width?: 'auto' | 'small' | 'large'
}

const useStyles = makeStyles<Theme, AreaSubstrateItemCellProps>(
  () => ({
    root: {
      padding: '0.25em 1em',
      verticalAlign: 'middle',
      background: 'white',
      width: ({ width, isControl }) => {
        if (isControl) {
          return 42
        }
        switch (width) {
          case 'small':
            return '7em'
          case 'large':
            return '9.1em'
          default:
            return 'auto'
        }
      }
    }
  }),
  {
    name: 'AreaSubstrateItemCell'
  }
)

function AreaSubstrateItemCell({ isPrep, ...props }: AreaSubstrateItemCellProps) {
  const classes = useStyles({ isPrep, ...props })

  return <ItemTableCell {...props} valign="middle" classes={classes} />
}

export default AreaSubstrateItemCell
